import * as classnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'
import TrendingSash from '../../../components/trendingSash'
import SaleSash from '../../../components/saleSash'
import ItemCardAudioContent from '../itemCardAudioContent'
import ItemCardSmallSidebar from '../itemCardSmallSidebar'
import FeatureContainer from '../../../containers/feature'

import * as styles from './audioJungleItemCard.module.css'

class AudioJungleItemCard extends React.Component<IItemCard> {
  public render() {
    const { item, viewType } = this.props

    const rootClass = classnames(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    // sale sash overrides trending sash
    let sash = null
    if (item.trending) sash = <TrendingSash lazy />

    // For author driven price experiment
    if (item.original_price_cents)
      sash = (
        <FeatureContainer name="showWasNowPricing">
          <SaleSash lazy />
        </FeatureContainer>
      )

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          {sash}
          <ItemCardAudioContent {...this.props} />
          <div className={styles.sidebar}>
            <ItemCardSmallSidebar {...this.props} />
          </div>
        </article>
      </div>
    )
  }
}

export default AudioJungleItemCard
